// import store from '@/store'
import Moment from 'moment'
// import { ulid } from 'ulid';
import {
  imgBaseUrl,
  videoBaseUrl
} from '@/config/env'

export default {
  methods: {
    // 转换时间格式为 YYYY-MM-DD
    toShortDateFormat(date) {
      if (date) {
        return Moment(date).format('YYYY-MM-DD');
      } else {
        return '-'
      }
    },
    // 转换时间格式为 YYYY-MM-DD HH:mm:SS
    toLongDateFormat(date) {
      if (date) {
        return Moment(date).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '-'
      }
    },
    // 组装文件类路径
    // path   文件名
    // style  图片类文件尺寸格式 1. origin原文件 2.phone 3. h250
    getImageUrl(path, style) {
      let url = imgBaseUrl + path;
      // if (!path) {
      //   path = 'IMG/123.jpg';
      // }

      if (!style || style == 'origin') {
        return url;
      } else {
        return url + "/" + style;
      }
    },
    getVideoUrl(path) {
      return videoBaseUrl + path;
    },
    getVideoUrlQCloud(path) {
      return imgBaseUrl + path;
    },
    getImageUrlDdf(path) {
      return 'https://www.ddfddf.com' + path;
    },
    // 根据日期倒序排序
    sortByDate(prop) {
      return function (obj1, obj2) {
        let val1 = obj1[prop];
        let val2 = obj2[prop];
        if (val1 < val2) {
          return 1;
        } else if (val1 > val2) {
          return -1;
        } else {
          return 0;
        }
      }
    },
    // 是否登录
    gIsLogin() {
      let loginTime = window.localStorage.getItem('login_time'),
        now = new Date().getTime();
      return loginTime && Number(loginTime) + 86400000 > now;
    },
    //图片居中显示
    gCenterImg(e, f) { //f: 1-按短边显示， 2-按长边显示
      let img = e.currentTarget,
        parent = img.parentNode,
        iw = img.width,
        ih = img.height,
        imgWH = iw / ih,
        pw = parent.clientWidth,
        ph = parent.clientHeight,
        parentWH = pw / ph,
        flag = f == 2 ? parentWH / imgWH : imgWH / parentWH;
      if (flag < 1) {
        img.style.height = 'auto';
        img.style.marginLeft = 0;
        img.style.width = '100%';
        img.style.marginTop = (ph - pw / imgWH) / 2 + 'px';
      } else {
        img.style.width = 'auto';
        img.style.marginTop = 0;
        img.style.height = '100%';
        img.style.marginLeft = (pw - ph * imgWH) / 2 + 'px';
      }
    },
    // 获取requestNo
    // getRequestNo() {
    //   return ulid();
    // },
  }
}